import {useLocation, useNavigate} from 'react-router-dom';
import {Tab, Tabs, Toolbar} from '@mui/material';
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";
import {getActiveNavigationPath, navigationItems} from './navigationConfig';

function NavBar() {
    const {t} = useAppTranslation();
    const history = useNavigate();
    const location = useLocation();
    const toolbarStyle = {display: {xs: 'none', md: 'flex'}, justifyContent: 'center', minHeight: '64px'};

    const handleChange = (event: any, newValue: string) => {
        history(newValue);
    };

    const activeTab = getActiveNavigationPath(location.pathname);

    return (
        <Toolbar sx={toolbarStyle}>
                <Tabs value={activeTab} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                    {navigationItems.map(item => <Tab key={item.path} label={t(item.translationKey)} value={item.path}/>) }
                </Tabs>
        </Toolbar>
    );
}

export default NavBar;
